module.exports = __webpack_public_path__ + "static/img/DLR_Logo.6f319eee.svg";